import { render, staticRenderFns } from "./shipment-bill.vue?vue&type=template&id=5f3b003f&scoped=true&"
import script from "./shipment-bill.vue?vue&type=script&lang=js&"
export * from "./shipment-bill.vue?vue&type=script&lang=js&"
import style0 from "./shipment-bill.vue?vue&type=style&index=0&id=5f3b003f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b003f",
  null
  
)

export default component.exports